import { DeleteOutlined, DownOutlined, EditOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type LabelsModuleSpecsFragment } from '../../../../api/fragments/LabelsModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useUpdateLabelsModuleDrawer } from './updateLabelsModuleDrawer';

export type LabelsModuleActionsProps = {
    module: LabelsModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const LabelsModuleActions = ({ module, permissions }: LabelsModuleActionsProps) => {
    const { t } = useTranslation(['labelsModule', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);

    const updateLabelsModuleDrawer = useUpdateLabelsModuleDrawer(module);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('labelsModule:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateLabelsModuleDrawer.open,
        },
        hasDeletePermission && {
            label: t('labelsModule:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('labelsModule:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {updateLabelsModuleDrawer.render()}
        </>
    );
};

export default LabelsModuleActions;
